module.exports = __webpack_public_path__ + "static/img/kilamajaro.a68d3b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/kilamajaro.jpg
// module id = yZmd
// module chunks = 1